/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Src_PhotoInputs */

const en_funnel_src_photo = /** @type {(inputs: Funnel_Src_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo of a page`)
};

const es_funnel_src_photo = /** @type {(inputs: Funnel_Src_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto de una página`)
};

/**
* | output |
* | --- |
* | "Photo of a page" |
*
* @param {Funnel_Src_PhotoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_src_photo = /** @type {((inputs?: Funnel_Src_PhotoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Src_PhotoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_src_photo(inputs)
	return en_funnel_src_photo(inputs)
});